"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importDefault(require("react"));
const typestyle_1 = require("typestyle");
const theme_1 = require("../../../../editor/theme");
const Colors_1 = require("../../../../Colors");
const Main = typestyle_1.style({
    display: 'flex',
    padding: `6px 12px`,
    fontSize: 12,
    cursor: 'pointer',
    scrollSnapAlign: 'end',
    $nest: Object.assign(Object.assign({}, Object.keys(theme_1.GraphQLColors).reduce((a, b) => {
        a[`.MenuItemText-${b}`] = {
            color: `${theme_1.GraphQLColors[b]}dd`,
        };
        return a;
    }, {})), { '.MenuItemText': {
            transition: 'color .25s ease-in-out',
            width: '100%',
            $nest: {
                '&:hover': {
                    color: Colors_1.Colors.grey[0],
                },
            },
        } }),
});
exports.MenuItem = ({ node, onClick }) => {
    return (react_1.default.createElement("div", { className: Main, onClick: onClick },
        react_1.default.createElement("span", { className: `MenuItemText MenuItemText-${node.type.name}` }, node.name)));
};
